module.exports = __webpack_public_path__ + "media/images/app-page-2637913a46d31666070c618e46b35fe7.jpg";